import Alert from "./alert"

const ALERT_VARIANTS = {
	error: {
		icon: "fa-solid fa-triangle-exclamation",
		iconClass: "text-coral"
	},
	success: {
		icon: "fa-solid fa-circle-check",
		iconClass: "text-green-600"
	},
	info: {
		icon: "fa-solid fa-circle-info",
		iconClass: "text-petrol"
	},
	warning: {
		icon: "fa-solid fa-circle-exclamation",
		iconClass: "text-yellow-600"
	}
}

export default class GlobalAlerts {
	constructor() {
		this.instances = new Set()
		this.container = this.ensureContainer()
	}

	ensureContainer() {
		let container = document.getElementById("app-alerts-container")
		if (container) return container

		container = document.createElement("div")
		container.id = "app-alerts-container"
		container.setAttribute("aria-live", "assertive")
		container.className = "pointer-events-none fixed inset-x-0 top-4 z-50 flex flex-col items-center gap-3 px-4 sm:items-end"
		document.body.appendChild(container)

		return container
	}

	bootstrap(selector = ".alert") {
		document.querySelectorAll(selector).forEach((element) => this.attach(element))
	}

	attach(element, options = {}) {
		const instance = new Alert(element, {
			...options,
			onHide: (alertInstance) => {
				this.instances.delete(alertInstance)
				if (typeof options.onHide === "function") options.onHide(alertInstance)
			}
		})

		this.instances.add(instance)
		return instance
	}

	show(message, options = {}) {
		const {
			variant = "error",
			duration = 3,
			title = "",
			icon,
			iconClass
		} = options

		const element = this.buildElement({
			message,
			variant,
			title,
			icon,
			iconClass
		})

		this.container.appendChild(element)

		return this.attach(element, {
			autoHideDelay: duration,
			removeOnHide: true
		})
	}

	error(message, options = {}) {
		return this.show(message, { ...options, variant: "error" })
	}

	success(message, options = {}) {
		return this.show(message, { ...options, variant: "success" })
	}

	info(message, options = {}) {
		return this.show(message, { ...options, variant: "info" })
	}

	warning(message, options = {}) {
		return this.show(message, { ...options, variant: "warning" })
	}

	buildElement({ message, variant, title, icon, iconClass }) {
		const config = ALERT_VARIANTS[variant] || ALERT_VARIANTS.error
		const wrapper = document.createElement("div")
		wrapper.className = "alert pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
		wrapper.innerHTML = `
			<div class="p-4">
				<div class="flex items-start gap-3">
					<div class="shrink-0 ${iconClass || config.iconClass}">
						<i class="${icon || config.icon}"></i>
					</div>
					<div class="min-w-0 flex-1 pt-0.5">
						${title ? `<p class="m-0 p-0 text-sm font-semibold text-gray-900">${title}</p>` : ""}
						<p class="m-0 p-0 text-sm text-gray-700">${message}</p>
					</div>
					<div class="flex shrink-0">
						<button type="button" aria-label="Cerrar" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-600 focus:outline-hidden">
							<i class="fa-solid fa-xmark"></i>
						</button>
					</div>
				</div>
			</div>
		`

		return wrapper
	}
}